import SalesOrderDetailMobile from "mobile/pages/sales/SalesOrderDetailMobile";

export default function InvoiceDetailMobile() {
  return <SalesOrderDetailMobile mode="invoice" />;
}
